var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle },
    on: { close: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c(
                        "form",
                        { on: { submit: handleSubmit } },
                        [
                          _c(
                            "ModalContent",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "actions",
                                    fn: function () {
                                      return [
                                        _c("UIButton", {
                                          staticClass: "mr-3",
                                          attrs: {
                                            variant: "outline",
                                            buttonText: "Cancel",
                                          },
                                          on: { click: _vm.handleClose },
                                        }),
                                        _c("UIButton", {
                                          attrs: {
                                            processing: _vm.processing,
                                            buttonText: "Submit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return handleSubmit(_vm.onSubmit)
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  rules: "required_field",
                                  name: "Review",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              attrs: {
                                                errors: errors,
                                                title: "Review*",
                                              },
                                            },
                                            [
                                              _c("FormTextArea", {
                                                attrs: {
                                                  invalid: Boolean(
                                                    errors.length
                                                  ),
                                                  name: "review",
                                                },
                                                model: {
                                                  value: _vm.localReview,
                                                  callback: function ($$v) {
                                                    _vm.localReview = $$v
                                                  },
                                                  expression: "localReview",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("ValidationProvider", {
                                attrs: {
                                  rules: "min_value:0.5",
                                  name: "Score",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              attrs: {
                                                errors: errors,
                                                title: "Score*",
                                              },
                                            },
                                            [
                                              _c("RatingStars", {
                                                model: {
                                                  value: _vm.localScore,
                                                  callback: function ($$v) {
                                                    _vm.localScore = $$v
                                                  },
                                                  expression: "localScore",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }